module.exports = __webpack_public_path__ + "static/media/roof.1f537954.png";